/* OCTAGON - "Benachrichtige mich, wenn wieder verfuegbar"

   Przycisk pokazuje sie TYLKO gdy wybrany wariant jest niedostepny.
   Okno z formularzem lezy w <template> wewnatrz bloku add-to-cart,
   bo formularz Shopify NIE MOZE stac w srodku formularza koszyka
   (zagniezdzone <form> przegladarka wyrzuca przy parsowaniu).
   Tresc <template> jest inertna, wiec formularz przezywa - JS
   przenosi go do <body> przy pierwszym otwarciu.

   Dostepnosc wariantu czytamy z JSON wygenerowanego przez Liquid,
   NIE z wygladu przycisku: motyw przy zmianie wariantu odswieza
   wylacznie [ref="addToCartButton"], wiec wszystko obok niego bywa
   nieaktualne (ta sama pulapka co przy przedsprzedazy).

   NAPISY (od 12.08.2026, punkt 18 - francuski i wloski):
   ida z window.OCT_I18N, ktore wypisuje snippets/octagon-strings.liquid
   w layout/theme.liquid. Kazdy napis ma fallback na niemiecki, wiec
   brak snippetu niczego nie wywraca. Miejsce na wartosc to @x@.

   TRESC MAILA zostaje PO NIEMIECKU celowo - to wiadomosc do Dawida,
   nie do klienta. */
(function () {
  'use strict';

  var DLG_ID = 'oct-bis';
  var timer = null;
  var observer = null;

  function T() { return window.OCT_I18N || {}; }

  function data() {
    var el = document.querySelector('script[data-oct-bis]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function ensureDialog() {
    var dlg = document.getElementById(DLG_ID);
    if (dlg) return dlg;
    var tpl = document.querySelector('template[data-oct-bis-tpl]');
    if (!tpl || !tpl.content) return null;
    document.body.appendChild(tpl.content.cloneNode(true));
    return document.getElementById(DLG_ID);
  }

  function variantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function variant(d) {
    if (!d || !d.variants || !d.variants.length) return null;
    var id = variantId();
    if (!id) return d.variants.length === 1 ? d.variants[0] : null;
    for (var i = 0; i < d.variants.length; i++) {
      if (String(d.variants[i].id) === id) return d.variants[i];
    }
    return null;
  }

  function sync() {
    var btns = document.querySelectorAll('[data-oct-bis-open]');
    if (!btns.length) return;
    var v = variant(data());
    var show = !!v && v.a === false;
    for (var i = 0; i < btns.length; i++) btns[i].hidden = !show;
  }

  function setVal(sel, val) {
    var el = document.querySelector('#' + DLG_ID + ' ' + sel);
    if (el) el.value = val;
  }

  function open() {
    var dlg = ensureDialog();
    if (!dlg) return;
    var d = data();
    var v = variant(d);
    var name = (d && d.product) || '';
    var size = (v && v.t && v.t !== 'Default Title') ? v.t : '';
    setVal('[data-oct-bis-product]', name);
    setVal('[data-oct-bis-size]', size);
    setVal('[data-oct-bis-link]', window.location.href);
    setVal('[data-oct-bis-body]', 'Benachrichtigung gewuenscht: ' + name + (size ? ' / Groesse ' + size : '') + ' - ' + window.location.href);

    var lbl = dlg.querySelector('[data-oct-bis-label]');
    if (lbl) {
      if (size) {
        var pat = T().bis_size || 'Gr\u00f6sse @x@';
        lbl.textContent = pat.replace('@x@', size);
      } else {
        lbl.textContent = T().bis_item || 'dieser Artikel';
      }
    }

    if (dlg.showModal && !dlg.open) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    var mail = dlg.querySelector('input[type="email"]');
    if (mail) { try { mail.focus(); } catch (e) {} }
  }

  function close() {
    var dlg = document.getElementById(DLG_ID);
    if (!dlg) return;
    if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-oct-bis-open]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-oct-bis-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('change', function () {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  });

  function watch() {
    if (observer) return;
    var host = document.querySelector('product-form-component') || document.querySelector('form[action*="/cart/add"]');
    if (!host || !window.MutationObserver) return;
    observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 80);
    });
    observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  }

  function boot() {
    sync();
    watch();
    if (window.location.search.indexOf('contact_posted=true') > -1) {
      var dlg = ensureDialog();
      if (dlg && dlg.querySelector('[data-oct-bis-ok]')) open();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('popstate', function () {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  });
})();
